import {
  _autolocateLocationFields,
  IAutolocateLocationFields,
} from './DexeroForm/_autolocateLocationFields';
import { _autoUploadImages, IAutoUploadImages } from './DexeroForm/_autoUploadImages';
import {
  _closeChildFormViaAjax,
  ICloseChildFormViaAjax,
} from './DexeroForm/_closeChildFormViaAjax';
import { _datepickers, IDatepickers } from './DexeroForm/_datepickers';
import { _formBindings, IFormBindings } from './DexeroForm/_formBindings';
import {
  _hookupSearchInFormLinkSearchPopup,
  IHookupSearchInFormLinkSearchPopup,
} from './DexeroForm/_hookupSearchInFormLinkSearchPopup';
import {
  _initFieldsFormlinkWithChilds,
  IInitFieldsFormlinkWithChilds,
} from './DexeroForm/_initFieldsFormlinkWithChilds';
import { _initGeneratePostJson, IInitGeneratePostJson } from './DexeroForm/_initGeneratePostJson';
import { _initPasswordFields, IInitPasswordFields } from './DexeroForm/_initPasswordFields';
import { _initRadioUnCheck, IInitRadioUnCheck } from './DexeroForm/_initRadioUnCheck';
import { _initReCaptchaFields, IInitReCaptchaFields } from './DexeroForm/_initReCaptchaFields';
import { _initSignatureFields, IInitSignatureFields } from './DexeroForm/_initSignatureFields';
import { _initTooltips, IInitTooltips } from './DexeroForm/_initTooltips';
import { _initWYSIWYG, IInitWYSIWYG } from './DexeroForm/_initWYSIWYG';
import { _loadChildFormViaAjax, ILoadChildFormViaAjax } from './DexeroForm/_loadChildFormViaAjax';
import { _loadDataEntryChild, ILoadDataEntryChild } from './DexeroForm/_loadDataEntryChild';
import { _maskCustomFields, IMaskCustomFields } from './DexeroForm/_maskCustomFields';
import { _maskDecimalFields, IMaskDecimalFields } from './DexeroForm/_maskDecimalFields';
import { _maskMoneyFields, IMaskMoneyFields } from './DexeroForm/_maskMoneyFields';
import { _maskNumberFields, IMaskNumberFields } from './DexeroForm/_maskNumberFields';
import { _maskPercentFields, IMaskPercentFields } from './DexeroForm/_maskPercentFields';
import { _maskPhoneNumbers, IMaskPhoneNumbers } from './DexeroForm/_maskPhoneNumbers';
import { _maskPosteNumbers, IMaskPosteNumbers } from './DexeroForm/_maskPosteNumbers';
import { _maskZipCodes, IMaskZipCodes } from './DexeroForm/_maskZipCodes';
import {
  _processLinkedAutoDates,
  IProcessLinkedAutoDates,
} from './DexeroForm/_processLinkedAutoDates';
import { _removeEntryViaAjax, IRemoveEntryViaAjax } from './DexeroForm/_removeEntryViaAjax';
import { _resetFileUpload, IResetFileUpload } from './DexeroForm/_resetFileUpload';
import { _saveFormViaAjax, ISaveFormViaAjax } from './DexeroForm/_saveFormViaAjax';
import {
  _setImageUploadButtonElms,
  ISetImageUploadButtonElms,
} from './DexeroForm/_setImageUploadButtonElms';
import { _textAreaCharCounter, ITextAreaCharCounter } from './DexeroForm/_textAreaCharCounter';
import { _toggleAriaExpander, IToggleAriaExpander } from './DexeroForm/_toggleAriaExpander';
import { _validateEmail, IValidateEmail } from './DexeroForm/_validateEmail';
import {
  _validateReCaptchaFields,
  IValidateReCaptchaFields,
} from './DexeroForm/_validateReCaptchaFields';
import { _warnFileOverwrite, IWarnFileOverwrite } from './DexeroForm/_warnFileOverwrite';
import {
  checkAutoCompleteForMatch,
  ICheckAutoCompleteForMatch,
} from './DexeroForm/checkAutoCompleteForMatch';
import { clearFieldError, IClearFieldError } from './DexeroForm/clearFieldError';
import { displayJsonErrors, IDisplayJsonErrors } from './DexeroForm/displayJsonErrors';
import {
  findDataEntryStoreValues,
  IFindDataEntryStoreValues,
} from './DexeroForm/findDataEntryStoreValues';
import {
  forceUniqueSelectValues,
  IForceUniqueSelectValues,
} from './DexeroForm/forceUniqueSelectValues';
import {
  formLinkSearchChangePage,
  IFormLinkSearchChangePage,
} from './DexeroForm/formLinkSearchChangePage';
import { formLinkSelect, IFormLinkSelect } from './DexeroForm/formLinkSelect';
import {
  formVariablesCalculate,
  IFormVariablesCalculate,
} from './DexeroForm/formVariablesCalculate';
import { getFieldProperties, IGetFieldProperties } from './DexeroForm/getFieldProperties';
import { getFieldRealValue, IGetFieldRealValue } from './DexeroForm/getFieldRealValue';
import { gotToPreviousPage, IGotToPreviousPage } from './DexeroForm/gotToPreviousPage';
import {
  handleQuickSaveButtonClick,
  IHandleQuickSaveButtonClick,
} from './DexeroForm/handleQuickSaveButtonClick';
import { IIsDateExpression, isDateExpression } from './DexeroForm/isDateExpression';
import { IOnSubformInlineEdit, onSubformInlineEdit } from './DexeroForm/onSubformInlineEdit';
import { IOnSubformAjaxEdit, onSubformAjaxEdit } from './DexeroForm/onSubformAjaxEdit';
import {
  IRefreshFieldRelatedValues,
  refreshFieldRelatedValues,
} from './DexeroForm/refreshFieldRelatedValues';
import { IResetForm, resetForm } from './DexeroForm/resetForm';
import { IResetFormGroupStatus, resetFormGroupStatus } from './DexeroForm/resetFormGroupStatus';
import { ISaveAndGotoSubCard, saveAndGotoSubCard } from './DexeroForm/saveAndGotoSubCard';
import {
  ISaveAndGotoSubCardSummaryPage,
  saveAndGotoSubCardSummaryPage,
} from './DexeroForm/saveAndGotoSubCardSummaryPage';
import { ISaveFormForLater, saveFormForLater } from './DexeroForm/saveFormForLater';
import { ISelectAllChildNodes, selectAllChildNodes } from './DexeroForm/selectAllChildNodes';
import { ISelectAllParentNode, selectAllParentNode } from './DexeroForm/selectAllParentNode';
import { ISetFieldValue, setFieldValue } from './DexeroForm/setFieldValue';
import { IShowFormGroupError, showFormGroupError } from './DexeroForm/showFormGroupError';
import { IShowFormGroupSuccess, showFormGroupSuccess } from './DexeroForm/showFormGroupSuccess';
import { IShowFormGroupWarning, showFormGroupWarning } from './DexeroForm/showFormGroupWarning';
import {
  IShowFormLinkSearchPopup,
  showFormLinkSearchPopup,
} from './DexeroForm/showFormLinkSearchPopup';
import subformQuickFilterBindings from './DexeroForm/subformQuickFilter';
import { ISubmitDataWorkflow, submitDataWorkflow } from './DexeroForm/submitDataWorkflow';

export interface IDexeroForm {
  _autolocateLocationFields: IAutolocateLocationFields;
  _autoUploadImages: IAutoUploadImages;
  _closeChildFormViaAjax: ICloseChildFormViaAjax;
  _datepickers: IDatepickers;
  _formBindings: IFormBindings;
  _hookupSearchInFormLinkSearchPopup: IHookupSearchInFormLinkSearchPopup;
  _initFieldsFormlinkWithChilds: IInitFieldsFormlinkWithChilds;
  _initGeneratePostJson: IInitGeneratePostJson;
  _initPasswordFields: IInitPasswordFields;
  _initRadioUnCheck: IInitRadioUnCheck;
  _initReCaptchaFields: IInitReCaptchaFields;
  _initSignatureFields: IInitSignatureFields;
  _initTooltips: IInitTooltips;
  _initWYSIWYG: IInitWYSIWYG;
  _loadChildFormViaAjax: ILoadChildFormViaAjax;
  _loadDataEntryChild: ILoadDataEntryChild;
  _maskCustomFields: IMaskCustomFields;
  _maskDecimalFields: IMaskDecimalFields;
  _maskMoneyFields: IMaskMoneyFields;
  _maskNumberFields: IMaskNumberFields;
  _maskPercentFields: IMaskPercentFields;
  _maskPhoneNumbers: IMaskPhoneNumbers;
  _maskPosteNumbers: IMaskPosteNumbers;
  _maskZipCodes: IMaskZipCodes;
  _processLinkedAutoDates: IProcessLinkedAutoDates;
  _removeEntryViaAjax: IRemoveEntryViaAjax;
  _resetFileUpload: IResetFileUpload;
  _saveFormViaAjax: ISaveFormViaAjax;
  _setImageUploadButtonElms: ISetImageUploadButtonElms;
  _textAreaCharCounter: ITextAreaCharCounter;
  _toggleAriaExpander: IToggleAriaExpander;
  _validateEmail: IValidateEmail;
  _validateReCaptchaFields: IValidateReCaptchaFields;
  _warnFileOverwrite: IWarnFileOverwrite;
  checkAutoCompleteForMatch: ICheckAutoCompleteForMatch;
  clearFieldError: IClearFieldError;
  displayJsonErrors: IDisplayJsonErrors;
  findDataEntryStoreValues: IFindDataEntryStoreValues;
  forceUniqueSelectValues: IForceUniqueSelectValues;
  formLinkSearchChangePage: IFormLinkSearchChangePage;
  formLinkSelect: IFormLinkSelect;
  formVariablesCalculate: IFormVariablesCalculate;
  getFieldProperties: IGetFieldProperties;
  getFieldRealValue: IGetFieldRealValue;
  gotToPreviousPage: IGotToPreviousPage;
  handleQuickSaveButtonClick: IHandleQuickSaveButtonClick;
  isDateExpression: IIsDateExpression;
  onBeforeFieldActions?: (serializedFormData: string) => JQuery.Deferred<string>;
  onBeforeFormVariablesCalculate?: (serializedFormData: string) => JQuery.Deferred<string>;
  onSubformAjaxEdit: IOnSubformAjaxEdit;
  onSubformInlineEdit: IOnSubformInlineEdit;
  refreshFieldRelatedValues: IRefreshFieldRelatedValues;
  resetForm: IResetForm;
  resetFormGroupStatus: IResetFormGroupStatus;
  saveAndGotoSubCard: ISaveAndGotoSubCard;
  saveAndGotoSubCardSummaryPage: ISaveAndGotoSubCardSummaryPage;
  saveFormForLater: ISaveFormForLater;
  selectAllChildNodes: ISelectAllChildNodes;
  selectAllParentNode: ISelectAllParentNode;
  setFieldValue: ISetFieldValue;
  showFormGroupError: IShowFormGroupError;
  showFormGroupSuccess: IShowFormGroupSuccess;
  showFormGroupWarning: IShowFormGroupWarning;
  showFormLinkSearchPopup: IShowFormLinkSearchPopup;
  subformQuickFilterBindings: IDCA.IGenericFunc;
  submitDataWorkflow: ISubmitDataWorkflow;
}

const DexeroForm: IDexeroForm = {
  // Request browser location on autolocate lat/long fields
  _autolocateLocationFields,

  // Upload images as soon as they are selected with file input to allow for cropping before submit
  _autoUploadImages,

  // Close subform that was loaded via ajax directly into main form
  _closeChildFormViaAjax,

  // Init datepickers
  _datepickers,

  // Bindings
  _formBindings,

  // Listen to enter keydown inside input to trigger search
  _hookupSearchInFormLinkSearchPopup,

  // Init all linked form fields that have children
  _initFieldsFormlinkWithChilds,

  // Generate Webservice post JSON on submit
  _initGeneratePostJson,

  // Handle password field to show/hide clear value
  _initPasswordFields,

  // Allow user to uncheck radio buttons
  _initRadioUnCheck,

  // Init invisible recaptcha fields
  _initReCaptchaFields,

  // Init Signature canvas fields
  _initSignatureFields,

  // Init tooltips
  _initTooltips,

  // Init WYSIWYG Editor
  _initWYSIWYG,

  // Load subform directly in main form to allow user to add subcards dynamically
  _loadChildFormViaAjax,

  // Load child data entry view
  _loadDataEntryChild,

  _maskCustomFields,

  _maskDecimalFields,

  _maskMoneyFields,

  _maskNumberFields,

  _maskPercentFields,

  _maskPhoneNumbers,

  _maskPosteNumbers,

  _maskZipCodes,

  // Allow for setting of end date based on start date and units to increment by
  _processLinkedAutoDates,

  // Remove a dataEntry without page reload
  _removeEntryViaAjax,

  // Remove the file from the data entry right away
  _resetFileUpload,

  // Save a form via ajax and get response
  _saveFormViaAjax,

  // Setting image upload field button elements after image upload
  _setImageUploadButtonElms,

  _textAreaCharCounter,

  _toggleAriaExpander,

  // Validate if string is a valid email
  _validateEmail,

  // Validate hidden google recaptcha fields
  _validateReCaptchaFields,

  // Show warning if user is about to select a new file to upload, and there's already a file uploaded
  _warnFileOverwrite,

  // Check if autocomplete has a valid value
  checkAutoCompleteForMatch,

  // Clear from row error
  clearFieldError,

  displayJsonErrors,

  // Get dataEntry store value of field
  findDataEntryStoreValues,

  // Force unique select values in a select group
  forceUniqueSelectValues,

  // Pagination inside the pop up form link pop up field
  formLinkSearchChangePage,

  // Select a value inside a form linked pop up window
  formLinkSelect,

  // Calculates the form variables for the current page
  formVariablesCalculate,

  // Get Field Properties
  getFieldProperties,

  getFieldRealValue,

  // Go to previous page of form
  gotToPreviousPage,

  // Quick save current form
  handleQuickSaveButtonClick,

  // Check if date expression from velocity
  isDateExpression,

  // Run after user edits a subform via ajax
  onSubformAjaxEdit,

  // Run after user inline edits a subform
  onSubformInlineEdit,

  // Filter child linked form fields by parent
  refreshFieldRelatedValues,

  // Rest whole form
  resetForm,

  // Reset form group to non validated status
  resetFormGroupStatus,

  // When we click on edit/or delete, to go to subcard, we save the main form first
  saveAndGotoSubCard,

  // Save current form page, and go to summary page
  saveAndGotoSubCardSummaryPage,

  // Save form for later / Need to implement a bette redirect when subform later
  saveFormForLater,

  // Make all child nodes active/inactive on parent node click
  selectAllChildNodes,

  // Make parent node active in tree on child click
  selectAllParentNode,

  // Set value of field by ID
  setFieldValue,

  // Show error for form Group
  showFormGroupError,
  // Show success for form Group
  showFormGroupSuccess,

  // Show warning for form Group
  showFormGroupWarning,

  // Display values from a linked field in a pop up
  showFormLinkSearchPopup,

  // Bindings for subform quick filter
  subformQuickFilterBindings,

  submitDataWorkflow,
};

export default DexeroForm;
